module.exports = __webpack_public_path__ + "src/assets/img/favicon-white.6084976f.svg";